import { Grid } from "@mui/material";
import VideoCard from "./VideoCard";

function Dashboard({ setVideoId, allVideos }) {
   const videoGrid = allVideos.map((video) => (
    <Grid key={video._id} item xs={12} sm={6} md={3} lg={3}>
      <VideoCard setVideoId={setVideoId} video={video} />
    </Grid>
  ));

  return (
    <Grid container rowSpacing={4} columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
      {videoGrid}
    </Grid>
    
  );
}

export default Dashboard;
